
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/statistieken",
      function () {
        return require("private-next-pages/statistieken.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/statistieken"])
      });
    }
  